export class Parentesco { 
    tipoParentesco: string;
    codigoParentesco: string 
    
    static instance() {
      return new this();
    }
  }